import { render, staticRenderFns } from "./UltimateBeneficiary.vue?vue&type=template&id=77ffd56d&scoped=true"
import script from "./UltimateBeneficiary.vue?vue&type=script&lang=js"
export * from "./UltimateBeneficiary.vue?vue&type=script&lang=js"
import style0 from "./UltimateBeneficiary.vue?vue&type=style&index=0&id=77ffd56d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ffd56d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ffd56d')) {
      api.createRecord('77ffd56d', component.options)
    } else {
      api.reload('77ffd56d', component.options)
    }
    module.hot.accept("./UltimateBeneficiary.vue?vue&type=template&id=77ffd56d&scoped=true", function () {
      api.rerender('77ffd56d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MerchantKYC/components/UltimateBeneficiary.vue"
export default component.exports